var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.622 17.438c-.395 0-.773-.183-1.04-.503L1.488 9.614C.267 8.273-.704 5.747.674 3.15 1.405 1.775 2.565.821 3.858.537c1.364-.3 2.785.085 3.9 1.054.321.279.604.593.846.936.203-.301.437-.58.698-.827.97-.922 2.214-1.338 3.501-1.18 2.1.262 3.799 2.09 4.132 4.446.242 1.704-.193 3.233-1.328 4.676l-5.934 7.281a1.36 1.36 0 0 1-1.043.515h-.008"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.944524e1.svg";
export { ForwardRef as ReactComponent };